import { createUseStyles } from 'react-jss'
import { colors } from '../../../variables.style'

const heading = {
  fontFamily: 'Raleway, sans-serif',
  fontVariantNumeric: 'lining-nums',
  margin: 0,
  marginBottom: 15
}

export const style = {
  content: {
    maxWidth: 600,
    '& p': {
      marginBottom: 15
    },
    '& h3': {
      ...heading,
      fontSize: 20,
      marginTop: 50,
      marginBottom: 24,
      textTransform: 'uppercase',
      textAlign: 'center'
    },
    '& h4': {
      ...heading,
      fontSize: 18,
      marginTop: 24,
      marginBottom: 16
    },
    '& h5': {
      ...heading,
      fontSize: 16,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      marginTop: 18,
      marginBottom: 16
    },
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      fontSize: 13,
      '& th': {
        border: `1px solid ${colors.brandDark}`,
        color: 'white',
        backgroundColor: colors.brandDark,
        fontWeight: 'normal',
        textAlign: 'left',
        padding: 5
      },
      '& td': {
        border: `1px solid ${colors.borderGray}`,
        textAlign: 'left',
        padding: 5
      },
      '& tr:nth-child(odd)': {
        backgroundColor: colors.tableRowStripedBackground
      }
    },
    '& .katex': {
      fontSize: 16, // bringing the font size down to the standard font size
      lineHeight: 1.15, // line height is slightly less than standard because katex has a different font
      '& .sizing.reset-size6.size3': {
        fontSize: '0.8em' // this is intended to target subscripts - default is 0.7em - making it bigger for readability
      }
    }
  }
}

export const useStyles = createUseStyles(style)
